export const BASE_URL = "https://provider.meemplay.com";
export const socketBaseUrl = "provider-socket.meemplay.com/websocket";

export const API_ENDPOINTS = {
  gameConfig: `${BASE_URL}/api/games/gameconfig/getconfig`,
  roundResults: `${BASE_URL}/api/rounds/list/getallroundsresult`,
} as const;
